import { useRef } from "react";
import { send } from "./api.js";
import "./manualPracticeEditor.css";

export interface ManualPracticeDraft { id: string; name: string; minutes: string; seconds: string }
export function manualPracticeValues(draft: ManualPracticeDraft) {
  const minutes = Number(draft.minutes), seconds = Number(draft.seconds);
  const total = minutes + seconds / 60;
  if (!Number.isInteger(minutes) || !Number.isInteger(seconds) || minutes < 0 || seconds < 0 || seconds > 59
    || total <= 0 || total > 480 || !draft.name.trim() || draft.name.trim().length > 200) {
    throw new Error("Enter what you practised and a duration between one second and eight hours.");
  }
  return { minutes: total, name: draft.name.trim() };
}
export function saveManualPracticeEntry(studentId: string, draft: ManualPracticeDraft) {
  return send("PATCH", `/me/students/${encodeURIComponent(studentId)}/practice/${encodeURIComponent(draft.id)}`, manualPracticeValues(draft));
}
export function ManualPracticeEditor({ draft, onChange, onSave, onCancel, busy }: {
  draft: ManualPracticeDraft; onChange: (draft: ManualPracticeDraft) => void;
  onSave: () => Promise<unknown> | void; onCancel: () => void; busy: boolean;
}) {
  const saving = useRef(false);
  return <form className="manual-practice-editor" onSubmit={event => {
    event.preventDefault();
    if (busy || saving.current) return;
    saving.current = true;
    void Promise.resolve(onSave()).finally(() => { saving.current = false; });
  }}>
    <label className="stack"><span>What did you practise?</span><input type="text" required maxLength={200} disabled={busy} value={draft.name} onChange={event => onChange({ ...draft, name: event.target.value })} /></label>
    <div className="manual-practice-duration">
      <label className="stack"><span>Minutes</span><input type="number" required min={0} max={480} step={1} disabled={busy} value={draft.minutes} onChange={event => onChange({ ...draft, minutes: event.target.value })} /></label>
      <label className="stack"><span>Seconds</span><input type="number" required min={0} max={59} step={1} disabled={busy} value={draft.seconds} onChange={event => onChange({ ...draft, seconds: event.target.value })} /></label>
    </div>
    <div className="row"><button type="submit" className="small" disabled={busy || !draft.name.trim()}>{busy ? "Saving…" : "Save changes"}</button><button type="button" className="quiet small" disabled={busy} onClick={onCancel}>Cancel</button></div>
  </form>;
}
